module.exports = __webpack_public_path__ + "static/EuclidFlex-Semibold-WebS-c7a773a1337a9011bc5cd544cce085c7.woff";